import React, { useState } from 'react';
import { Box, Typography, Button, Alert } from '@mui/material';
import { SearchBar } from '../components/SearchBar';
import { Title } from '../types';

export const Submit: React.FC = () => {
    const [selectedTitle, setSelectedTitle] = useState<Title | null>(null);
    const [submitted, setSubmitted] = useState(false);

    const handleSubmit = () => {
        if (selectedTitle) {
            // This will be connected to Supabase later
            console.log('Submitting request for:', selectedTitle);
            setSubmitted(true);
        }
    };

    return (
        <Box>
            <Typography variant="h4" gutterBottom>
                Submit a Request
            </Typography>
            <Typography variant="body1" paragraph>
                Search for a show or movie you'd like to see adapted into a book.
            </Typography>

            <SearchBar onTitleSelect={setSelectedTitle} />

            {selectedTitle && (
                <Box sx={{ mt: 3 }}>
                    <Typography variant="h6">Selected Title:</Typography>
                    <Typography>{selectedTitle.title_name} ({selectedTitle.release_year})</Typography>
                    <Button
                        variant="contained"
                        onClick={handleSubmit}
                        sx={{ mt: 2 }}
                    >
                        Submit Request
                    </Button>
                </Box>
            )}

            {submitted && (
                <Alert severity="success" sx={{ mt: 2 }}>
                    Your request has been submitted successfully!
                </Alert>
            )}
        </Box>
    );
};